import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import ClinicalResourceLibrary from "./ClinicalResourceLibrary";
import Inbox from "./messages/Inbox";

const Home = () => {
  const getUserId = () => {
    return JSON.parse(localStorage.getItem("safyInfo") || "{}").user?.safyInfo
      .SOARUserId;
  };

  return (
    <div className="justify-content-center">
      <div className="m-4">
        <img src={require("../assets/SAFYLogo.png")} alt="logo" width="350" />
      </div>
      <div className="ms-4 mb-4 h3 text-safy2-1">SAFY SOAR PORTAL</div>
      <AuthenticatedTemplate>
        <ClinicalResourceLibrary />
        <Inbox userId={getUserId()} />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate></UnauthenticatedTemplate>
    </div>
  );
};

export default Home;
